import { api } from "./api";
import { ISalaryPricingLog, ISalaryPricingStats, SalaryChangeType } from "../types/salaryPricingLog.type";

export const salaryPricingLogApi = {
  // Получение журнала изменений зарплат
  getSalaryPricingLogs: async (params?: {
    page?: number;
    limit?: number;
    workerId?: string;
    changeType?: SalaryChangeType;
    startDate?: string;
    endDate?: string;
    salaryId?: string;
  }) => {
    const response = await api.get("/salary-pricing-log", { params });
    return response.data;
  },

  // Получение одного записи журнала по ID
  getSalaryPricingLogById: async (id: string) => {
    const response = await api.get(`/salary-pricing-log/${id}`);
    return response.data;
  },

  // Получение статистики изменений зарплат
  getSalaryPricingStats: async (params?: {
    workerId?: string;
    startDate?: string;
    endDate?: string;
  }) => {
    const response = await api.get("/salary-pricing-log/stats", { params });
    return response.data as { overallStats: any; changeTypeStats: any[] };
  },

  // Получение истории изменений для конкретного работника
  getWorkerSalaryHistory: async (workerId: string, params?: {
    page?: number;
    limit?: number;
  }) => {
    const response = await api.get(`/salary-pricing-log/worker/${workerId}`, { params });
    return response.data;
  },
}; 